import React, { useContext, useState, useRef } from 'react'
import Loader from 'react-loader-spinner'

import imgVideoBanner from '../../../assets/images/frequent-questions/imgVideoBanner.png'
import { Context } from '../../../context/app-context'
import userSessionStorage from '../../../utils/userSessionStorage'
import { competitionId } from '../../../constants/activity-constants'
import * as endpoints from '../../../constants/api-constants'
import { axiosInstance } from '../../../shared/services/axios-instance'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

import './form-and-video-section.scss'

const FormAndVideoSection = ({ isMobile }) => {
  const [commentContent, setCommentContent] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isGood, setIsGood] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const { dispatch } = useContext(Context)
  const textArea = useRef(null)
  const session = new userSessionStorage()


  const handleOpenVideo = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: 'modalVideo',
          props: {
            blur: true,
            close: () => {
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
            handleSuccess: () => {
              window.location.reload()
            },
          },
          wrapperProps: {
            className: `modalVideo`,
          },
        },
      },
    })
  }

  const setError = (message, sended) => {
    sended && setIsGood(true)
    setErrorMessage(message)
    setTimeout(() => {
      setErrorMessage('')
      setIsGood(false)
    }, 3000)
  }

  const handleTextChange = () => {
    setCommentContent(textArea.current.value)
  }

  const handleSendQuestion = async event => {
    event.preventDefault()

    if (commentContent.length < 10) {
      setError('Tu pregunta es demasiado corta.')
    } else {
      setIsLoading(true)
      try {
        const payload = {
          competitionId: competitionId,
          description: `${commentContent}`,
        }
        let tokenId = session.getToken() ? session.getToken().idToken : ''
        const config = {
          headers: tokenId
            ? {
                Authorization: tokenId,
              }
            : undefined,
        }
        await axiosInstance
          .post(endpoints.postConcourseParticipation, payload, config)
          .then(resp => {
            if (resp.data.status === 400) setError(resp.data.userMessage)
            else {
              setCommentContent('')
              textArea.current.value = ''
              setError('Pregunta enviada correctamente', true)
            }
          })
          .catch(error => setError(error))
      } catch (error) {
        console.log(error)
      }
      pushEventDataLayer(
        'Interacciones - Preguntas frecuentes',
        'yogo-yogo',
        'click',
        'Enviar'
      )
      setIsLoading(false)
    }
  }
  return (
    <section className="f-formAndVideoSection-container">
      <div className="f-formAndVideoSection-container__formSection">
        <p className="f-formAndVideoSection-container__formSection__textInfo">
          <b> ¿NO ESTÁ LA QUE BUSCAS?</b> <br /> Escribe la tuya aquí. Las
          preguntas más frecuentes las estaremos publicando
        </p>
        <div className="f-formAndVideoSection-container__formSection__textAreaContent">
          <textarea
            name="historia"
            ref={textArea}
            onChange={handleTextChange}
            minLength={500}
            maxLength={2000}
          />
        </div>
        {errorMessage && (
          <p
            className={`f-formAndVideoSection-container__formSection__message ${
              isGood && 'sended'
            }`}
          >
            {errorMessage}
          </p>
        )}
        <button
          className="f-proDefense-button"
          onClick={handleSendQuestion}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader type="Oval" color="#ffffff" height={22} width={30} />
          ) : (
            'Enviar'
          )}
        </button>
      </div>
      <div className="f-formAndVideoSection-container__videoSection">
        <p>Mira este video que también puede resolver tus dudas</p>
        {isMobile ? (
          <button
            className="f-proDefense-button f-proDefense-button--videoButton"
            onClick={handleOpenVideo}
          >
            VER VIDEO
          </button>
        ) : (
          <figure onClick={handleOpenVideo}>
            <img src={imgVideoBanner} alt="video como resolver dudas" />
          </figure>
        )}
      </div>
    </section>
  )
}

export default FormAndVideoSection
